// Public, unauthenticated location-share request(s). Uses the plain `api`
// client (no Authorization header) — this is called from a page with no
// login session, so authApi's Bearer-token/force-logout flow would be wrong
// here.
import { api } from "./user-requests";
import { PUBLIC_LOCATION_SHARE } from "./api-urls";

export const getPublicLocation = (token) => {
  return api.get(`${PUBLIC_LOCATION_SHARE}/${token}`);
};
